import React from 'react';
import './OrderHeader.css';
import moment from 'moment';

const OrderHeader = ({ order }) => {
  function formatDate(dateString) {
    return moment(dateString).format('DD MMM YYYY');
  }

  function getStatusColor(status) {
    switch (status?.toLowerCase()) {
      case 'delivered':
        return 'var(--color-darkGreen)';
      case 'processing':
        return 'var(--color-lightOrange)';
      case 'cancelled':
        return 'var(--color-darkRed)';
      default:
        return 'var(--color-secondary)';
    }
  }

  function getStatusBg(status) {
    switch (status?.toLowerCase()) {
      case 'delivered':
        return 'var(--color-lightGreen)';
      case 'processing':
        return 'var(--color-lightOrangeBg)';
      case 'cancelled':
        return 'var(--color-lightRedBg)';
      default:
        return 'var(--color-lightSecondary)';
    }
  }

  const statusTimeline = [
    { label: 'Ordered' },
    { label: 'Processing' },
    { label: 'Delivered' },
  ];

  const currentStatusIdx = statusTimeline.findIndex(
    s => s.label.toLowerCase() === order?.order_status?.toLowerCase(),
  );

  return (
    <div className="order-header">
      <div className="order-header__row">
        <div className="order-header__id-section">
          <span className="order-header__id-label">Order ID:</span>
          <h2 className="order-header__id">{order?._id}</h2>
        </div>
        <div
          className="order-header__status"
          style={{ 
            backgroundColor: getStatusBg(order?.order_status),
            color: getStatusColor(order?.order_status)
          }}
        >
          {order?.order_status?.toUpperCase()}
        </div>
      </div>
      <p className="order-header__date">
        Ordered on {formatDate(order?.order_date)}
      </p>
      {order?.order_status !== 'cancelled' && (
        <div className="order-header__stepper">
          {statusTimeline.map((step, idx) => {
            const isActive = idx <= currentStatusIdx;
            return (
              <React.Fragment key={step.label}>
                <div className="order-header__step">
                  <div className={`order-header__step-circle ${isActive ? 'order-header__step-circle--active' : ''}`}>
                    <div className="order-header__step-dot"></div>
                  </div>
                  <span
                    className={`order-header__step-label ${
                      isActive ? 'order-header__step-label--active' : ''
                    }`}
                  >
                    {step.label}
                  </span>
                </div>
                {idx < statusTimeline.length - 1 && (
                  <div
                    className={`order-header__step-line ${
                      isActive ? 'order-header__step-line--active' : ''
                    }`}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default OrderHeader; 